// frontend/src/utils/emailMasker.js
// Email masking utility for privacy protection
//
// Rules:
// 1. If local part (before @) has <= 2 characters: show **@domain
// 2. If local part has > 2 characters: show first_char***last_char@domain
//
// Examples:
// - john.doe@example.com → j***e@example.com
// - ab@test.com → **@test.com
// - abc@test.com → a***c@test.com
// - a@test.com → **@test.com

/**
 * Mask an email address for privacy
 * @param {string} email - The email address to mask
 * @returns {string} The masked email address, or empty string if invalid
 */
export function maskEmail(email) {
  // Handle null, undefined, or non-string inputs
  if (!email || typeof email !== 'string') {
    return '';
  }

  // Trim whitespace
  email = email.trim();

  // Find the @ symbol
  const atIndex = email.indexOf('@');

  // Invalid email format - no @ symbol or @ at start/end
  if (atIndex <= 0 || atIndex === email.length - 1) {
    return '';
  }

  const localPart = email.substring(0, atIndex);
  const domain = email.substring(atIndex + 1);

  // Validate domain has at least one character
  if (domain.length === 0) {
    return '';
  }

  // Apply masking rules based on local part length
  let maskedLocal;

  if (localPart.length <= 2) {
    // Short local part: show **
    maskedLocal = '**';
  } else {
    // Longer local part: show first***last
    const firstChar = localPart.charAt(0);
    const lastChar = localPart.charAt(localPart.length - 1);
    maskedLocal = `${firstChar}***${lastChar}`;
  }

  return `${maskedLocal}@${domain}`;
}

export default { maskEmail };
